export default function Sidebar({
  nodes,
  start,
  end,
  mode,
  modes,
  result,
  isLoading,
  currentMode,
  onStartChange,
  onEndChange,
  onModeChange,
  onFindRoute,
}) {
  const nodeList = Object.values(nodes);

  const modeMessages = {
    fastest: "⚡ Here's the fastest route.",
    safe: "🌱 Here's the safest path — well-lit and populated.",
    calm: "🧠 Here's a calmer route — less crowded and flatter.",
    eco: "🌍 Here's the more eco-friendly path.",
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-section">
        <h2 className="sidebar-title">Plan Your Route</h2>

        <label className="field-label">From</label>
        <select
          className="field-select"
          value={start}
          onChange={(e) => onStartChange(e.target.value)}
        >
          {nodeList.map((n) => (
            <option key={n.id} value={n.id}>
              {n.icon} {n.name}
            </option>
          ))}
        </select>

        <label className="field-label">To</label>
        <select
          className="field-select"
          value={end}
          onChange={(e) => onEndChange(e.target.value)}
        >
          {nodeList.map((n) => (
            <option key={n.id} value={n.id}>
              {n.icon} {n.name}
            </option>
          ))}
        </select>
      </div>

      <div className="sidebar-section">
        <h2 className="sidebar-title">Route Mode</h2>
        <div className="mode-grid">
          {modes.map((m) => (
            <button
              key={m.id}
              className={`mode-card ${mode === m.id ? "active" : ""}`}
              style={{ "--card-color": m.color }}
              onClick={() => onModeChange(m.id)}
            >
              <span className="mode-emoji">{m.emoji}</span>
              <span className="mode-name">{m.label}</span>
              <span className="mode-desc">{m.description}</span>
            </button>
          ))}
        </div>
      </div>

      <button
        className="find-route-btn"
        onClick={onFindRoute}
        disabled={isLoading || start === end}
        style={{ "--btn-color": currentMode?.color || "#10b981" }}
      >
        {isLoading ? (
          <span className="spinner">Finding route...</span>
        ) : (
          `${currentMode?.emoji} Find ${currentMode?.label} Route`
        )}
      </button>

      {result && (
        <div className="result-panel">
          <p className="result-message">{modeMessages[mode]}</p>

          <div className="result-stats">
            <div className="stat">
              <span className="stat-value">{result.stats.totalDistance}m</span>
              <span className="stat-label">Distance</span>
            </div>
            <div className="stat">
              <span className="stat-value">~{result.stats.estimatedMinutes} min</span>
              <span className="stat-label">Walk time</span>
            </div>
            <div className="stat">
              <span className="stat-value">💡 {result.stats.avgLighting}/10</span>
              <span className="stat-label">Avg lighting</span>
            </div>
            <div className="stat">
              <span className="stat-value">👥 {result.stats.avgCrowd}/10</span>
              <span className="stat-label">Avg crowd</span>
            </div>
            <div className="ai-reasoning" style={{ marginTop: '12px', padding: '10px', background: '#1e293b', borderRadius: '8px' }}>
    <h3 style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#94a3b8' }}>🤖 AI Safety Tip</h3>
    <p style={{ margin: 0, fontSize: '13px', color: '#e2e8f0' }}>{result.aiReasoning}</p>
  </div>
          </div>

          <div className="route-steps">
            <h3>Route</h3>
            {result.path.map((nodeId, i) => {
              const node = nodes[nodeId];
              return (
                <div key={nodeId} className="route-step">
                  <div className="step-dot" style={{ "--dot-color": currentMode?.color }} />
                  <span>
                    {node.icon} {node.name}
                  </span>
                  {i < result.path.length - 1 && (
                    <div className="step-line" style={{ "--line-color": currentMode?.color }} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </aside>
  );
}